@if (flyout && node?.children.length > 1) {
  <div
    class="back is-open"
    (click)="back()"
    >
    <span>
      <cx-icon [type]="iconType.CARET_LEFT"></cx-icon>
      {{ "common.back" | cxTranslate }}
    </span>
  </div>
}

@for (child of node?.children; track child) {
  <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: 0 }">
  </ng-container>
}

<!-- we generate links in a recursive manner -->
<ng-template #nav let-node="node" let-depth="depth" let-open="open" let-parent="parent">
  <nav
    (click)="toggleOpenNode($event, node)"
    (mouseenter)="onMouseEnter($event)"
    (keydown.space)="toggleOpen($event)"
    (keydown.esc)="back()"
    >
    @if (
      node.url && (!node.children || node.children?.length === 0)) {
      @if (isNodeVisible(node, parent)) {
        <cx-generic-link
          [url]="node.url"
          [target]="node.target"
          [style]="node.styleAttributes"
          [class]="node.styleClasses"
          >
          @if (flyout) {
            <span class="expand-flyout" [ngClass]="getNodeLinkClass(node)">
              <span [ngClass]="getNodeLinkIconClass(node)">
                <cx-icon [type]="customIconType.LOGOUT" class="pl-0"></cx-icon>
              </span>
              <span>{{ node.title }}</span>
            </span>
          }
          @if (!flyout) {
            <span>{{ node.title }}</span>
          }
          @if (flyout && node.children?.length > 0) {
            <cx-icon
              [type]="iconType.CARET_DOWN"
            ></cx-icon>
          }
        </cx-generic-link>
      }
    } @else {
      @if ((node.children?.length || !!depth) && isNodeVisible(node, parent)) {
        @if (node.title?.length > 0) {
          <span class="is-parent"
            [ngClass]="!!node.children?.length ? 'navHeading' : 'navItem'"
            [attr.tabindex]="flyout && (depth === 0 || node.url) ? 0 : -1"
            >
            @if (flyout) {
              <span class="expand-flyout" [ngClass]="getBackTitleClass(node)">
                <span class="expand-flyout--nested" [ngClass]="getBackClass(node)">
                  @if (flyout && node.children?.length > 0) {
                    <cx-icon
                      class="mr-2 pl-0"
                      [type]="iconType.CARET_LEFT"
                    ></cx-icon>
                  }
                </span>
                {{ node.title }}
              </span>
            }
            @if (!flyout) {
              <span>{{ node.title }}</span>
            }
            @if (isRoot(node)) {
              @if (flyout && node.children?.length > 0) {
                <cx-icon
                  [type]="iconType.CARET_DOWN" class="d-none d-lg-flex"
                ></cx-icon>
              }
              @if (flyout && node.children?.length > 0 && !isOpen) {
                <cx-icon
                  [type]="iconType.CARET_RIGHT" class="d-flex d-lg-none small"
                ></cx-icon>
              }
            } @else {
              <span [ngClass]="getExpandClass(node)">
                @if (flyout && node.children?.length > 0) {
                  <cx-icon
                    [type]="iconType.CARET_RIGHT"
                  ></cx-icon>
                }
              </span>
            }
          </span>
        }
      }
    }



    <!-- we add a wrapper to allow for better layout handling in CSS -->
    @if (node.children?.length > 0 && isNodeOpen(node)) {
      <div class="wrapper">
        @if (node.url) {
          <cx-generic-link
            [url]="node.url"
            [target]="node.target"
            class="all"
            >
            {{ "navigation.shopAll" | cxTranslate : { navNode: node.title } }}
          </cx-generic-link>
        }
        <div
          class="childs"
          [attr.depth]="getTotalDepth(node)"
          [attr.wrap-after]="node.children?.length > wrapAfter ? wrapAfter : null"
          [attr.columns]="getColumnCount(node.children?.length)"
          >
          @if (isNodeOpen(node)) {
            @for (child of node.children; track child) {
              <ng-container
                *ngTemplateOutlet="nav; context: { parent: node, node: child, depth: depth + 1, open: isNodeOpen(child) }"
                >
              </ng-container>
            }
          }
        </div>
      </div>
    }
  </nav>
</ng-template>
